import {exportTxnToExcelApi, exportTxnToExcelApiForLessTxn} from "../api/api";

export const exportTransactions = (searchFilter) => async (dispatch) => {
  try {
    await exportTxnToExcelApi(searchFilter);
  } catch (error) {
    console.error("Export Transaction Error: ", error);
    throw error;
  }
};

export const exportTxnForBrowserDownload = (searchFilter) => async (dispatch) => {
  try {
    await exportTxnToExcelApiForLessTxn(searchFilter);
  } catch (error) {
    console.error("Export Transaction Error: ", error);
    throw error;
  }
};